import { Component, OnInit, Inject } from '@angular/core';
import { TeamMember } from '@entities/team-member';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Department } from '@entities/department';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { OrgBuilderFacade } from '@app/org-builder/state/org-builder.facade';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { Observable } from 'rxjs';
import { froalaConfig } from '@app/shared/config/froala.config';

@Component({
   selector: 'app-department-edit',
   templateUrl: './department-edit.component.html',
   styleUrls: ['./department-edit.component.scss'],
})
export class DepartmentEditComponent implements OnInit {
   form: UntypedFormGroup;
   editAction: string;
   canEdit$: Observable<boolean>;

   editorConfig = {
      ...froalaConfig,
      editorClass: 'editor',
      toolbarInline: true,
      inlineMode: false,
      placeholderText: 'Purpose',
      minHeight: 100,
   };

   notesEditorConfig = {
      ...froalaConfig,
      editorClass: 'editor',
      toolbarInline: true,
      inlineMode: false,
      placeholderText: 'Notes',
      minHeight: 100,
   };

   private orgBuilderFacade: OrgBuilderFacade;

   constructor(
      @Inject(MAT_DIALOG_DATA)
      data: {
         department: Department;
         service: OrgBuilderFacade;
      }
   ) {
      this.form = new UntypedFormGroup({
         id: new UntypedFormControl(),
         name: new UntypedFormControl(),
         purpose: new UntypedFormControl(),
         managerId: new UntypedFormControl(),
         businessUnitId: new UntypedFormControl(),
         order: new UntypedFormControl(),
         notes: new UntypedFormControl(),
      });
      this.form.patchValue(data.department);
      this.orgBuilderFacade = data.service;
      this.editAction = data.department.id ? 'Edit' : 'Add';
      this.canEdit$ = this.orgBuilderFacade.canEdit$;
   }

   ngOnInit() {}

   getControl(name: string): UntypedFormControl {
      return this.form.get(name) as UntypedFormControl;
   }

   save() {
      const department: Department = this.form.value;
      this.orgBuilderFacade.saveDepartment(department);
   }

   cancel() {
      this.orgBuilderFacade.cancelEditDepartment();
   }

   setManagerId(selectionEvent: MatAutocompleteSelectedEvent) {
      if (selectionEvent) {
         const id = selectionEvent.option.value.id;
         this.form.get('managerId').setValue(id);
         this.form.markAsDirty();
      } else {
         this.form.get('managerId').reset();
      }
   }
}
